import React, { useEffect, useState } from "react";
import courseStyle from "./courses.module.css";
import {
  ArrowWhiteIcon,
  BackArrowIcon,
  BackIcon,
  CrossIcon,
  DevIcon,
  Dropdown,
  DropdownIcon,
  DropUp,
  DropupIcon,
  FilterIcon,
  ForwardIcon,
  RatingIcon,
  SearchIcon,
  StarIcons,
  StudentsIcon,
  ClockIcon,
  GetInTouch,
  BlueBegginerIcon,
} from "../../svg";

import { Box, CircularProgress, Slider } from "@mui/material";
import { getCourseImageUrl, formatCourseDuration } from "../helper/courseMedia";
import { useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCourses,
  getCatSubCategories,
  getCourseLevel,
  getDuration,
  getPayment,
  getRating,
  setFilterValues,
  resetAndSetFilterValues,
  getSearchSuggession
} from "../redux/courseSlice";
import ErrorPage from "../../component/ErrorPage";

const GraduationCapIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M12 3L1.5 8.25L12 13.5L20.25 9.375V15.75H21.75V8.25L12 3Z" fill="#FFFFFF" />
    <path d="M4.5 11.1V15.3C4.5 15.3 7.5 18 12 18C16.5 18 19.5 15.3 19.5 15.3V11.1L12 14.85L4.5 11.1Z" fill="#FFFFFF" opacity="0.92" />
  </svg>
);

const BookFeatureIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M6 4.5h9.5A2.5 2.5 0 0 1 18 7v12.5H7.5A1.5 1.5 0 0 1 6 18V4.5Z" stroke="#1D83F8" strokeWidth="1.6" />
    <path d="M6 18a1.5 1.5 0 0 1 1.5-1.5H18" stroke="#1D83F8" strokeWidth="1.6" />
  </svg>
);

const LifetimePlayIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <circle cx="12" cy="12" r="8.25" stroke="#1D83F8" strokeWidth="1.6" />
    <path d="M10 8.8v6.4l5.2-3.2L10 8.8Z" fill="#1D83F8" />
  </svg>
);

const CertFeatureIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M7 3.5h7l3.5 3.5V19a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 19V5A1.5 1.5 0 0 1 7 3.5Z" stroke="#1D83F8" strokeWidth="1.6" />
    <path d="M14 3.5V7h3.5" stroke="#1D83F8" strokeWidth="1.6" />
    <path d="M8.5 12h7M8.5 15.5h5" stroke="#1D83F8" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const HeadsetFeatureIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M4.5 12a7.5 7.5 0 0 1 15 0" stroke="#1D83F8" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M4.5 12v3.5A2.5 2.5 0 0 0 7 18h1v-5.5H5.5A1 1 0 0 0 4.5 13.5V12Z" stroke="#1D83F8" strokeWidth="1.6" />
    <path d="M19.5 12v1.5a1 1 0 0 1-1 1H16V18h1a2.5 2.5 0 0 0 2.5-2.5V12Z" stroke="#1D83F8" strokeWidth="1.6" />
  </svg>
);

function valuetext(value) {
  return `${value}°C`;
}

const openAdvisorContact = () => {
  window.open("https://kingster.edu.in/contact-us/", "_blank");
};

const GuidanceCard = ({ styles }) => (
  <div className={styles.guidanceCard}>
    <div className={styles.guidanceIcon}>
      <GraduationCapIcon />
    </div>
    <h3 className={styles.guidanceTitle}>Need Guidance?</h3>
    <p className={styles.guidanceText}>
      Our experts are here to help you choose the right course.
    </p>
    <button
      type="button"
      className={styles.guidanceBtn}
      onClick={openAdvisorContact}
    >
      Talk to an Advisor
    </button>
  </div>
);

const FeaturesBar = ({ styles }) => (
  <section className={styles.featuresBar} aria-label="Platform benefits">
    <div className={styles.featureItem}>
      <span className={styles.featureIcon}>
        <BookFeatureIcon />
      </span>
      <div>
        <p className={styles.featureTitle}>Expert Instructors</p>
        <p className={styles.featureDesc}>Learn from industry professionals.</p>
      </div>
    </div>
    <div className={styles.featureItem}>
      <span className={styles.featureIcon}>
        <LifetimePlayIcon />
      </span>
      <div>
        <p className={styles.featureTitle}>Lifetime Access</p>
        <p className={styles.featureDesc}>
          Access course materials anytime, anywhere.
        </p>
      </div>
    </div>
    <div className={styles.featureItem}>
      <span className={styles.featureIcon}>
        <CertFeatureIcon />
      </span>
      <div>
        <p className={styles.featureTitle}>Certificate</p>
        <p className={styles.featureDesc}>
          Get certified and boost your career.
        </p>
      </div>
    </div>
    <div className={styles.featureItem}>
      <span className={styles.featureIcon}>
        <HeadsetFeatureIcon />
      </span>
      <div>
        <p className={styles.featureTitle}>24/7 Support</p>
        <p className={styles.featureDesc}>We&apos;re here to help you succeed.</p>
      </div>
    </div>
  </section>
);

const Courses = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getFiltersData = useSelector((state) => state.courses);
  const { isLoading, filterValues } = useSelector((state) => state.courses);
  const catSubcateData = getFiltersData?.catSubCategoriesData;
  const ratingsData = getFiltersData?.ratingData;
  const courseLevelData = getFiltersData?.courseLevelData;
  const paymentData = getFiltersData?.paymentData;
  const durationData = getFiltersData?.durationData;
  const getAllCoursesData = getFiltersData?.allCourseData?.courses;
  const pagination = getFiltersData?.allCourseData;

  //State
  const [filterCount, setFilterCount] = useState(0);
  const [searchItems, setSearchItems] = useState([])
  const [search, setSearch] = useState(null);
  const [catFilterOpen, setCatFilterOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null); // For selected categor
  const [rateFilterOpen, setRateFilterOpen] = useState(false);
  const [courseLabel, setCourseLabel] = useState(false);
  const [duration, setDuration] = useState(false);
  const [price, setPrice] = useState(false); // To toggle the price filter dropdown
  const [value, setValue] = useState([10, 10000]); // Default slider values [minPrice, maxPrice]
  const [isOpen, setIsOpen] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(true);
  const [selectedFilter, setSelectedFilter] = useState("All")

  //Filter state for mobile view
  const [filter, setFilter] = useState(false);
  const options = [
    { name: "All", value: "All" },
    { name: "trending", value: "trending" },
    { name: "latest", value: "latest" },
    { name: "Price - Low to High", value: "priceLowToHigh" },
    { name: "Price - High to Low", value: "priceHighToLow" }
  ];

  //Effects
  useEffect(() => {
    dispatch(getCatSubCategories());
    dispatch(getRating());
    dispatch(getDuration());
    dispatch(getPayment());
    dispatch(getCourseLevel());
  }, [dispatch]);


  useEffect(() => {
    dispatch(getAllCourses(filterValues));
  }, [
    dispatch, filterValues
  ]);


  const handleInputChange = (e) => {
    const value = e.target.value
    setSearch(value); // Update search state
    setShowSuggestions(!!value); // Show suggestions only if there's input
  };

  const handleClearInput = () => {
    setSearch(''); // Update search state
    dispatch(setFilterValues({ search: "" }));
    setSearchItems([]); // Clear suggestions    // setShowSuggestions(!!value); 
  }

  useEffect(() => {
    const getSearchData = async () => {
      if (!search) {
        // Reset filter and clear suggestions if search is empty
        dispatch(setFilterValues({ search: "" }));
        setSearchItems([]); // Clear suggestions
        return;
      }

      try {
        const result = await dispatch(getSearchSuggession(search)).unwrap();
        console.log("Search results:", result);

        // Update search items if result is valid
        if (result) {
          setSearchItems(result);
        }
      } catch (error) {
        console.error("Error fetching search suggestions:", error);
      }
    };

    getSearchData();
  }, [search]);


  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    dispatch(setFilterValues({ page: 1, sortBy: option?.value }))
    setSelectedFilter(option?.name)
    setIsOpen(false);
  };

  const toggleFilterMobileView = () => {
    setFilter(!filter);
  };
  const toggleCatFilter = () => {
    setCatFilterOpen(!catFilterOpen);
  };

  const updateFilterCount = (isIncrement) => {
    setFilterCount((prevCount) => isIncrement ? prevCount + 1 : prevCount - 1);
  };

  const toggleSubCatFilter = (categoryId) => {
    // Toggle the selected category
    setSelectedCategory((prevCategory) =>
      prevCategory === categoryId ? null : categoryId
    );
  };

  const toggleRateFilter = () => {
    setRateFilterOpen(!rateFilterOpen);
  };
  const toggleLabelFilter = () => {
    setCourseLabel(!courseLabel);
  };
  const togglePriceFilter = () => {
    setPrice(!price);
  };
  const toggleDurationFilter = () => {
    setDuration(!duration);
  };

  //Handle Select Subcategories
  const handleCategoryChange = (subcategory) => {
    const subcategoriesArray = filterValues?.subCategoryIds?.split(",").filter(Boolean); // Convert string to array and remove empty values
    const isSelected = subcategoriesArray.includes(subcategory._id);

    if (isSelected) {
      // Deselect subcategory
      const updatedArray = subcategoriesArray.filter(
        (id) => id !== subcategory._id
      );
      dispatch(setFilterValues({ subCategoryIds: updatedArray.join(","), page: 1, search: "" }));
      updateFilterCount(false);;
    } else {
      // Select subcategory
      const updatedArray = [...subcategoriesArray, subcategory._id];
      dispatch(setFilterValues({ subCategoryIds: updatedArray.join(","), page: 1 }));
      updateFilterCount(true);; // Increase count
    }
  };


  //Handle Select Rating
  const handleRatingChange = (rating) => {
    if (!filterValues?.ratings) {
      // Increment filter count when a new rating is selected
      updateFilterCount(true);;
    } else if (filterValues?.ratings !== rating) {
      // No change in filter count if switching between ratings
    } else {
      // Decrement filter count if the current rating is deselected
      dispatch(setFilterValues({ ratings: "", page: 1 }));
      updateFilterCount(false);;
      return
    }
    dispatch(setFilterValues({ ratings: rating, page: 1 }));
  };

  // handle Select course level
  const handleLevelChange = (level) => {
    const courseLevelArray = filterValues?.courseLevels.split(",").filter(Boolean);
    const isSelected = courseLevelArray.includes(level);

    if (isSelected) {
      // Remove the level if it's already selected
      const updatedArray = courseLevelArray.filter((item) => item !== level);
      dispatch(setFilterValues({ courseLevels: updatedArray.join(","), page: 1 }))

      updateFilterCount(false);;
    } else {
      // Add the level if it's not selected
      const updatedArray = [...courseLevelArray, level];
      dispatch(setFilterValues({ courseLevels: updatedArray.join(","), page: 1 }))
      updateFilterCount(true);;
    }
  };

  const handleSearchClick = async (nameOrCategory) => {
    try {
      setSearch(nameOrCategory);
      setFilterCount(0);
      setShowSuggestions(false);
      dispatch(resetAndSetFilterValues({ search: nameOrCategory, page: 1 }));

    } catch (error) {
      console.error('Failed to fetch product:', error);
    }
  };



  // Handle Select duration
  const handleDurationChange = (durationValue) => {
    const durationArray = filterValues?.durationOptions.split(",").filter(Boolean); // Convert string to array and remove empty values
    const isSelected = durationArray.includes(durationValue);

    if (isSelected) {
      // Remove duration if it's already selected
      const updatedArray = durationArray.filter(
        (item) => item !== durationValue
      );
      dispatch(setFilterValues({ durationOptions: updatedArray.join(","), page: 1 }))

      updateFilterCount(false);;
    } else {
      // Add duration to the selected list
      const updatedArray = [...durationArray, durationValue];
      dispatch(setFilterValues({ durationOptions: updatedArray.join(","), page: 1 }))
      updateFilterCount(true);;
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    dispatch(setFilterValues({ minPrice: newValue[0], maxPrice: newValue[1], page: 1 }))

  };

  const handleMinPriceChange = (event) => {
    const newMin = parseInt(event.target.value, 10) || 0;
    dispatch(setFilterValues({ minPrice: newMin, page: 1 }))

    setValue([newMin, value[1]]);
  };

  const handleMaxPriceChange = (event) => {
    const newMax = parseInt(event.target.value, 10) || 0;
    dispatch(setFilterValues({ maxPrice: newMax, page: 1 }))
    setValue([value[0], newMax]);
  };

  const capitalizeFirstLetters = (str) => {
    if (!str) return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleCheckboxChange = (label) => {
    if (filterValues?.priceOption === label) {
      dispatch(setFilterValues({ priceOption: "all" }))
      updateFilterCount(false);;
    } else {
      // If selected, increment count
      dispatch(setFilterValues({ priceOption: label, page: 1 }))
      updateFilterCount(true);
    }
  };

  const handleClearAll = async () => {
    try {
      setFilterCount(0)
      dispatch(resetAndSetFilterValues())
    } catch (error) {
      console.error("clearing attributes failed")
    }
  }

  const valuetext = (value) => `${value}`;
  // Function to handle clicking on the page number


  const handlePageClick = (page) => {
    if (page !== pagination?.currentPage) {
      dispatch(setFilterValues({ page }));
    }
  };

  // Function to handle clicking on previous
  const handlePreviousClick = () => {
    if (pagination?.currentPage > 1) {
      dispatch(setFilterValues({ page: pagination?.currentPage - 1 }));
    }
  };

  // Function to handle clicking on next
  const handleNextClick = () => {
    if (pagination?.currentPage < pagination?.totalPages) {
      dispatch(setFilterValues({ page: pagination?.currentPage + 1 }));
    }
  };

  // Render pagination numbers
  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= pagination?.totalPages; i++) {
      pages.push(
        <button
          key={i}
          className={
            i === pagination?.currentPage
              ? `${courseStyle.pagination__number} ${courseStyle.active}`
              : `${courseStyle.pagination__number}`
          }
          onClick={() => handlePageClick(i)}
        >
          {String(i).padStart(2, "0")} {/* Ensures numbers are 2 digits */}
        </button>
      );
    }
    return pages;
  };

  const ratingData = [
    {
      id: 0,
      rating: "5 Star",
      count: ratingsData?.fiveStarCount,
      value: 5,
    },
    {
      id: 1,
      rating: "4 Star & up",
      count: ratingsData?.fourStarAndAboveCount,
      value: 4,
    },
    {
      id: 2,
      rating: "3 Star & up",
      count: ratingsData?.threeStarAndAboveCount,
      value: 3,
    },
    {
      id: 3,
      rating: "2 Star & up",
      count: ratingsData?.twoStarAndAboveCount,
      value: 2,
    },
    {
      id: 4,
      rating: "1 Star & up",
      count: ratingsData?.oneStarAndAboveCount,
      value: 1,
    },
  ];
  const labelData = [
    {
      id: 0,
      label: "All Level",
      count: courseLevelData?.AllLevels,
      value: "Alllevel"
    },
    {
      id: 1,
      label: "Beginner",
      count: courseLevelData?.Beginner,
      value: "Beginner"
    },
    {
      id: 2,
      label: "Intermediate",
      count: courseLevelData?.Intermediate,
      value: "Intermediate"
    },
    {
      id: 3,
      label: "Expert",
      count: courseLevelData?.Advanced,
      value: "Advanced"
    },
  ];
  const priceData = [
    {
      id: 0,
      label: "paid",
      count: paymentData?.paid,
    },
    {
      id: 1,
      label: "free",
      count: paymentData?.free,
    },
  ];

  return (
    <div className={courseStyle.pageShell}>
    <div className={courseStyle.paddingmain}>
      <div className={courseStyle.pageHeader}>
        <p className={courseStyle.pageEyebrow}>Explore</p>
        <h1 className={courseStyle.pageTitle}>Courses</h1>
        <p className={courseStyle.pageSubtitle}>
          Find the right program and start learning at your pace.
        </p>
      </div>
      <div className={courseStyle.componentStyle}>
        <div className={courseStyle.childCompoStyle}>
          <div className={courseStyle.filterStyle}>
            <FilterIcon className={courseStyle.filterIconStyle} />{" "}
            <span className={courseStyle.filterText}>Filter</span>{" "}
            <span className={courseStyle.countStyle}>
              {Math.max(0, Math.abs(parseInt(filterCount) || 0))}
            </span>
          </div>
          {filterCount > 0 ? (
            <div className={courseStyle.clearAll} onClick={() => handleClearAll()}>
              Clear All
            </div>
          ) : null}
          <div style={{ width: "70%" }}>
            <div className={courseStyle.inputBox}>
              <SearchIcon />
              <input
                type="text"
                placeholder="UI/UX Design"
                value={search}
                onChange={(e) => handleInputChange(e)}
              />
              {search !== null && search.length >= 1 && (
                <div
                  onClick={handleClearInput}
                  style={{ padding: "5px 8px", display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                  <CrossIcon />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={courseStyle.container}>
          <label className={courseStyle.sortText}>Sort by:</label>
          <div className={courseStyle.dropdown}>
            <div
              onClick={toggleDropdown}
              className={courseStyle.selectedOption}
            >
              {selectedFilter}{" "}
              <span className={courseStyle.dropdownIconStyle}>
                {isOpen ? <DropupIcon /> : <DropdownIcon />}
              </span>
            </div>
            {isOpen && (
              <ul className={courseStyle.optionsList}>
                {options?.map((option) => (
                  <li
                    key={option?.value}
                    onClick={() => handleOptionClick(option)}
                    className={courseStyle.option}
                  >
                    {option?.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>

      <div className={courseStyle.mobileComponentStyle}>
        {!filter ? (
          <div className={courseStyle.inputBox}>
            <SearchIcon />
            <input
              type="text"
              placeholder="UI/UX Design"
              value={search}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        ) : null}
        {!filter ? (
          <div>
            <div className={courseStyle.filterMobileStyle}>
              <div
                className={courseStyle.filterStyle}
                onClick={toggleFilterMobileView}
              >
                <FilterIcon />{" "}
                <span className={courseStyle.filterText}>Filter</span>
              </div>
              <div className={courseStyle.container}>
                <label className={courseStyle.sortText}>Sort by:</label>
                <div className={courseStyle.dropdown}>
                  <div
                    onClick={toggleDropdown}
                    className={courseStyle.selectedOption}
                  >
                    {selectedFilter}{" "}
                    <span>
                      <ArrowDropDownIcon />
                    </span>
                  </div>
                  {isOpen && (
                    <ul className={courseStyle.optionsList}>
                      {options?.map((option) => (
                        <li
                          key={option?.value}
                          onClick={() => handleOptionClick(option)}
                          className={courseStyle.option}
                        >
                          {option?.name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className={courseStyle.resultText}>
            </div>
          </div>
        ) : null}
      </div>
      <div
        className={courseStyle.componentStyle}
        style={{ marginTop: 20, marginBottom: 10 }}
      >
        <div>
          <div className={courseStyle.suggestionList}>
            {showSuggestions && searchItems.length > 0 ? (
              <>
                <span>Suggestions: </span>
                {searchItems &&
                  searchItems
                    ?.slice(0, 10)
                    ?.map((item, index) => (
                      <li
                        key={index}
                        onClick={() => handleSearchClick(item)}
                      >
                        {item}  {index < searchItems.slice(0, 10).length - 1 && " | "}
                      </li>
                    ))}
              </>
            ) : null}
          </div>
        </div>
        {/* <div className={courseStyle.resultText}>

             { pagination?.suggestions[0]?.totalCount ?
                    
               {pagination?.suggestions[0]?.totalCount }  <span>results find for `${search}`</span>:null}
                </div> */}

        <div className={courseStyle.resultText}>
          {searchItems.length > 0 ? (
            <>
              {searchItems.length}{" "}
              <span>results found for "{search}"</span>
            </>
          ) : null}
        </div>
      </div>
      {!filter ? <div className={courseStyle.bottomLine} /> : null}
      <div className={courseStyle.app}>
        <div className={courseStyle.leftSideMenu}>
          <aside className={courseStyle.sidebar}>
            <div
              className={courseStyle.catContainerStyle}
              onClick={toggleCatFilter}
            >
              <div className={courseStyle.cateText}>CATEGORY</div>
              {catFilterOpen ? (
                <div>
                  <DropupIcon />
                </div>
              ) : (
                <div>
                  <DropdownIcon />
                </div>
              )}
            </div>
            {catFilterOpen && (
              <>
                {catSubcateData?.map((item, index) => (
                  <div className={courseStyle.bottomLine} key={index}>
                    <div
                      className={courseStyle.subCatContainerStyle}
                      onClick={() => toggleSubCatFilter(item._id)}
                    >
                      <div className={courseStyle.childCompoStyle}>
                        {/* <div>
                          <DevIcon /> 
                        </div> */}
                        <img src={item?.img}
                          width={30} />
                        <div
                          className={
                            selectedCategory === item._id
                              ? courseStyle.activeCatText
                              : courseStyle.inactiveCatText
                          }
                        >
                          {item.name}
                        </div>
                      </div>
                      <div>
                        {selectedCategory === item._id ? (
                          <DropUp />
                        ) : (
                          <Dropdown />
                        )}
                      </div>
                    </div>
                    {selectedCategory === item._id && (
                      <>
                        {item.subCategories?.map((val, subIndex) => (
                          <div
                            className={courseStyle.ratingStyle}
                            key={subIndex}
                          >
                            <div
                              className={courseStyle.childCompoStyle}
                              style={{ marginLeft: 5 }}
                            >
                              <div>
                                <input
                                  type="checkbox"
                                  checked={filterValues?.subCategoryIds.includes(val._id)}
                                  onChange={() => handleCategoryChange(val)}
                                />
                              </div>
                              <div
                                className={`${courseStyle.subCatText} ${filterValues?.subCategoryIds.includes(val._id) ? courseStyle.subCat : " "}`}
                              >
                                {val.name}
                              </div>
                            </div>
                            <div className={courseStyle.priceText}>
                              {val.totalCourses}
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                ))}
              </>
            )}
          </aside>
          {/* Rating filter hidden
          <aside className={courseStyle.sidebar}>
            <div
              className={courseStyle.catContainerStyle}
              onClick={toggleRateFilter}
            >
              <div className={courseStyle.cateText}>RATING</div>
              {rateFilterOpen ? (
                <div>
                  <DropupIcon />
                </div>
              ) : (
                <div>
                  <DropdownIcon />
                </div>
              )}
            </div>
            {rateFilterOpen && (
              <>
                {ratingData?.map((item, index) => (
                  <div className={courseStyle.ratingStyle} key={index}>
                    <div
                      className={courseStyle.childCompoStyle}
                      style={{ marginLeft: 5 }}
                    >
                      <div>
                        <input
                          type="checkbox"
                          checked={filterValues?.ratings === item.value}
                          onChange={() => handleRatingChange(item.value)}
                        />
                      </div>
                      <div className={courseStyle.subCatText}>
                        <StarIcons /> {item.rating}
                      </div>
                    </div>
                    <div className={courseStyle.priceText}>{item.count}</div>
                  </div>
                ))}
              </>
            )}
          </aside>
          */}
          <aside className={courseStyle.sidebar}>
            <div
              className={courseStyle.catContainerStyle}
              onClick={toggleLabelFilter}
            >
              <div className={courseStyle.cateText}>COURSE LEVEL</div>
              {courseLabel ? (
                <div>
                  <DropupIcon />
                </div>
              ) : (
                <div>
                  <DropdownIcon />
                </div>
              )}
            </div>
            {courseLabel && (
              <>
                {labelData?.map((item, index) => (
                  <div className={courseStyle.ratingStyle} key={index}>
                    <div
                      className={courseStyle.childCompoStyle}
                      style={{ marginLeft: 5 }}
                    >
                      <div>
                        <input
                          type="checkbox"
                          checked={filterValues?.courseLevels.includes(item.value)} // Check if the level is selected
                          onChange={() => handleLevelChange(item.value)} // Toggle level selection
                        />
                      </div>
                      <div className={courseStyle.subCatText}>{item.label}</div>
                    </div>
                    <div className={courseStyle.priceText}>{item.count}</div>
                  </div>
                ))}
              </>
            )}
          </aside>
          <aside className={courseStyle.sidebar}>
            <div
              className={courseStyle.catContainerStyle}
              onClick={togglePriceFilter}
            >
              <div className={courseStyle.cateText}>PRICE</div>
              {price ? (
                <div>
                  <DropupIcon />
                </div>
              ) : (
                <div>
                  <DropdownIcon />
                </div>
              )}
            </div>
            {price && (
              <div>
                <Box
                  sx={{
                    display: "inline-block",
                    margin: "0 auto",
                    width: "100%",
                    padding: "20px",
                  }}
                >
                  <Slider
                    getAriaLabel={() => "Price range"}
                    value={value}
                    onChange={handleChange}
                    valueLabelDisplay="auto"
                    getAriaValueText={valuetext}
                    min={0}
                    max={100000} // Adjust the range as needed
                  />
                </Box>
                <div className={courseStyle.priceRange}>
                  <div className={courseStyle.inputBox}>
                    <div>₹&nbsp;min:</div>
                    <input
                      type="number"
                      placeholder="10"
                      value={filterValues?.minPrice}
                      onChange={handleMinPriceChange}
                    />
                  </div>
                  <div className={courseStyle.inputBox}>
                    <div>₹&nbsp;max:</div>
                    <input
                      type="number"
                      placeholder="1000"
                      value={filterValues?.maxPrice}
                      onChange={handleMaxPriceChange}
                    />
                  </div>
                </div>
              </div>
            )}
            {price && (
              <>
                {priceData?.map((item, index) => (
                  <div className={courseStyle.ratingStyle} key={index}>
                    <div
                      className={courseStyle.childCompoStyle}
                      style={{ marginLeft: 5 }}
                    >
                      <div>
                        <input
                          type="checkbox"
                          checked={filterValues?.priceOption === item.label}
                          onChange={() => handleCheckboxChange(item.label)}
                        />
                      </div>
                      <div className={courseStyle.subCatText}>{item.label}</div>
                    </div>
                    <div className={courseStyle.priceText}>{item.count}</div>
                  </div>
                ))}
              </>
            )}
          </aside>
          <aside className={courseStyle.sidebar}>
            <div
              className={courseStyle.catContainerStyle}
              onClick={toggleDurationFilter}
            >
              <div className={courseStyle.cateText}>DURATION</div>
              {duration ? (
                <div>
                  <DropupIcon />
                </div>
              ) : (
                <div>
                  <DropdownIcon />
                </div>
              )}
            </div>
            {duration && (
              <>
                {durationData?.map((item, index) => (
                  <div className={courseStyle.ratingStyle} key={index}>
                    <div
                      className={courseStyle.childCompoStyle}
                      style={{ marginLeft: 5 }}
                    >
                      <div>
                        <input
                          type="checkbox"
                          checked={filterValues?.durationOptions.includes(item.duration)} // Check if duration is selected
                          onChange={() => handleDurationChange(item.duration)} // Toggle duration selection
                        />
                      </div>
                      <div className={courseStyle.subCatText}>
                        {item.duration}
                      </div>
                    </div>
                    <div className={courseStyle.priceText}>{item.count}</div>
                  </div>
                ))}
              </>
            )}
          </aside>
          <GuidanceCard styles={courseStyle} />
        </div>
        <main className={courseStyle.mainContent}>
          {isLoading ? (
            <div
              style={{
                display: "grid",
                placeItems: "center",
                height: "50vh",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <>
              {getAllCoursesData?.length > 0 ? (
                <>
                  <div className={courseStyle.cardStyle}>
                    {getAllCoursesData?.map((item, index) => (
                      <div
                        className={courseStyle.MainCardStyle}
                        onClick={() =>
                          navigate(
                            `/courses/Courses/CourseDetails/${item?._id}`
                          )
                        }
                        key={index}
                      >
                        <div className={courseStyle.imageWrap}>
                          <img
                            src={getCourseImageUrl(item?.thumbnail)}
                            className={courseStyle.imageView}
                            alt={item?.name}
                          />
                        </div>
                        <div className={courseStyle.cardBody}>
                          <div className={courseStyle.scoreStyle}>
                            <div className={courseStyle.businessStyle}>
                              {Array.isArray(item?.category) &&
                                item?.category?.map((cat, catIndex) => (
                                  <span key={catIndex}>
                                    {capitalizeFirstLetters(cat?.name)}
                                  </span>
                                ))}
                            </div>
                            <div className={courseStyle.totalPriceText}>
                              {item?.courseType === "LIVESTREAM" ? (
                                <div className={courseStyle.liveBadge}> • Live</div>
                              ) : (
                                <>₹ {item?.price}</>
                              )}
                            </div>
                          </div>
                          <div className={courseStyle.descStyle}>
                            {item?.title && item.title?.length > 56
                              ? capitalizeFirstLetters(
                                  `${item?.title?.substring(0, 56)}...`
                                )
                              : capitalizeFirstLetters(item?.title)}
                          </div>
                          <div className={courseStyle.cardFooter}>
                            <div className={courseStyle.cardMeta}>
                              {formatCourseDuration(item?.duration) ? (
                                <span className={courseStyle.metaItem}>
                                  <ClockIcon />
                                  {formatCourseDuration(item?.duration)}
                                </span>
                              ) : null}
                              {item?.courseLevel ? (
                                <span className={courseStyle.metaItem}>
                                  <BlueBegginerIcon />
                                  {item.courseLevel}
                                </span>
                              ) : null}
                            </div>
                            <span className={courseStyle.cardArrow} aria-hidden>
                              <GetInTouch />
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className={courseStyle.pagination}>
                    <div
                      className={courseStyle.pagination__arrow}
                      onClick={handlePreviousClick}
                      disabled={pagination?.currentPage === 1}
                    >
                      <BackIcon />
                    </div>
                    {renderPageNumbers()}
                    <div
                      className={courseStyle.pagination__arrow}
                      onClick={handleNextClick}
                      disabled={pagination?.currentPage === pagination?.totalPages}
                    >
                      <ForwardIcon />
                    </div>
                  </div>
                </>
              ) : (
                <ErrorPage />
              )}
            </>
          )}
        </main>
      </div>

      <div className={courseStyle.mobileViewCardContainer}>
        {filter ? (
          <div style={{ width: "100%" }}>
            <div className={courseStyle.filterHeaderStyle}>
              <div onClick={() => setFilter(!filter)}>
                <BackArrowIcon />
              </div>
              <div className={courseStyle.filterMobileText}>Filter</div>
              {filterCount > 0 ? (
                <div className={courseStyle.clearAlltext} onClick={() => handleClearAll()}>Clear All</div>
              ) : (null)}
            </div>
            <aside className={courseStyle.sidebar}>
              <div
                className={courseStyle.catContainerStyle}
                onClick={toggleCatFilter}
              >
                <div className={courseStyle.cateText}>CATEGORY</div>
                {catFilterOpen ? (
                  <div>
                    <DropupIcon />
                  </div>
                ) : (
                  <div>
                    <DropdownIcon />
                  </div>
                )}
              </div>
              {catFilterOpen && (
                <>
                  {catSubcateData?.map((item, index) => (
                    <div className={courseStyle.bottomLine} key={index}>
                      <div
                        className={courseStyle.subCatContainerStyle}
                        onClick={() => toggleSubCatFilter(item._id)}
                      >
                        <div className={courseStyle.childCompoStyle}>

                          <img src="https://kingster-dev-public.s3.ap-south-1.amazonaws.com/undefined/72517351071023258146.svg"
                            width={20} />
                          <div
                            className={
                              selectedCategory === item._id
                                ? courseStyle.activeCatText
                                : courseStyle.inactiveCatText
                            }
                          >
                            {item.name}
                          </div>
                        </div>
                        <div>
                          {selectedCategory === item._id ? (
                            <DropUp />
                          ) : (
                            <Dropdown />
                          )}
                        </div>
                      </div>
                      {selectedCategory === item._id && (
                        <>
                          {item.subCategories?.map((val, subIndex) => (
                            <div
                              className={courseStyle.ratingStyle}
                              key={subIndex}
                            >
                              {/* <div
                                className={courseStyle.childCompoStyle}
                                style={{ marginLeft: 5 }}
                              >
                                <div>
                                  <input
                                    type="checkbox"
                                    checked={subCategoryIds.includes(val._id)}
                                    onChange={() => handleCategoryChange(val)}
                                  />
                                </div>
                                <div className={courseStyle.subCatText}>
                                  {val.name}
                                </div>
                              </div> */}
                              <div
                                className={courseStyle.childCompoStyle}
                                style={{ marginLeft: 5 }}
                              >
                                <div>
                                  <input
                                    type="checkbox"
                                    checked={filterValues?.subCategoryIds.includes(val._id)}
                                    onChange={() => handleCategoryChange(val)}
                                  />
                                </div>
                                <div
                                  className={`${courseStyle.subCatText} ${filterValues?.subCategoryIds.includes(val._id) ? courseStyle.subCat : " "}`}
                                >
                                  {val.name}
                                </div>
                              </div>

                              <div className={courseStyle.priceText}>
                                {val.totalCourses}
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  ))}
                </>
              )}
            </aside>
            {/* Rating filter hidden
            <aside className={courseStyle.sidebar}>
              <div
                className={courseStyle.catContainerStyle}
                onClick={toggleRateFilter}
              >
                <div className={courseStyle.cateText}>RATING</div>
                {rateFilterOpen ? (
                  <div>
                    <DropupIcon />
                  </div>
                ) : (
                  <div>
                    <DropdownIcon />
                  </div>
                )}
              </div>
              {rateFilterOpen && (
                <>
                  {ratingData?.map((item, index) => (
                    <div className={courseStyle.ratingStyle} key={index}>
                      <div
                        className={courseStyle.childCompoStyle}
                        style={{ marginLeft: 5 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={filterValues?.ratings === item.value}
                            onChange={() => handleRatingChange(item.value)}
                          />
                        </div>
                        <div className={courseStyle.subCatText}>
                          <StarIcons /> {item.rating}
                        </div>
                      </div>
                      <div className={courseStyle.priceText}>{item.count}</div>
                    </div>
                  ))}
                </>
              )}
            </aside>
            */}
            <aside className={courseStyle.sidebar}>
              <div
                className={courseStyle.catContainerStyle}
                onClick={toggleLabelFilter}
              >
                <div className={courseStyle.cateText}>COURSE LEVEL</div>
                {courseLabel ? (
                  <div>
                    <DropupIcon />
                  </div>
                ) : (
                  <div>
                    <DropdownIcon />
                  </div>
                )}
              </div>
              {courseLabel && (
                <>
                  {labelData?.map((item, index) => (
                    <div className={courseStyle.ratingStyle} key={index}>
                      <div
                        className={courseStyle.childCompoStyle}
                        style={{ marginLeft: 5 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={filterValues?.courseLevels.includes(item.value)} // Check if the level is selected
                            onChange={() => handleLevelChange(item.value)} // Toggle level selection
                          />
                        </div>
                        <div className={courseStyle.subCatText}>
                          {item.label}
                        </div>
                      </div>
                      <div className={courseStyle.priceText}>{item.count}</div>
                    </div>
                  ))}
                </>
              )}
            </aside>
            <aside className={courseStyle.sidebar}>
              <div
                className={courseStyle.catContainerStyle}
                onClick={togglePriceFilter}
              >
                <div className={courseStyle.cateText}>PRICE</div>
                {price ? (
                  <div>
                    <DropupIcon />
                  </div>
                ) : (
                  <div>
                    <DropdownIcon />
                  </div>
                )}
              </div>
              {price && (
                <div>
                  <Box
                    sx={{
                      display: "inline-block",
                      margin: "0 auto",
                      width: 320,
                      padding: "20px",
                    }}
                  >
                    <Slider
                      getAriaLabel={() => "Price range"}
                      value={value}
                      onChange={handleChange}
                      valueLabelDisplay="auto"
                      getAriaValueText={valuetext}
                      min={0}
                      max={10000} // Adjust the range as needed
                    />
                  </Box>
                  <div className={courseStyle.priceRange}>
                    <div className={courseStyle.inputBox}>
                      <div>₹&nbsp;min:</div>
                      <input
                        type="number"
                        placeholder="10"
                        value={filterValues?.minPrice}
                        onChange={handleMinPriceChange}
                      />
                    </div>
                    <div className={courseStyle.inputBox}>
                      <div>₹&nbsp;max:</div>
                      <input
                        type="number"
                        placeholder="1000"
                        value={filterValues?.maxPrice}
                        onChange={handleMaxPriceChange}
                      />
                    </div>
                  </div>
                </div>
              )}
              {price && (
                <>
                  {priceData?.map((item, index) => (
                    <div className={courseStyle.ratingStyle} key={index}>
                      <div
                        className={courseStyle.childCompoStyle}
                        style={{ marginLeft: 5 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={filterValues?.priceOption === item.label}
                            onChange={() => handleCheckboxChange(item.label)}
                          />
                        </div>
                        <div className={courseStyle.subCatText}>
                          {item.label}
                        </div>
                      </div>
                      <div className={courseStyle.priceText}>{item.count}</div>
                    </div>
                  ))}
                </>
              )}
            </aside>
            <aside className={courseStyle.sidebar}>
              <div
                className={courseStyle.catContainerStyle}
                onClick={toggleDurationFilter}
              >
                <div className={courseStyle.cateText}>DURATION</div>
                {duration ? (
                  <div>
                    <DropupIcon />
                  </div>
                ) : (
                  <div>
                    <DropdownIcon />
                  </div>
                )}
              </div>
              {duration && (
                <>
                  {durationData?.map((item, index) => (
                    <div className={courseStyle.ratingStyle} key={index}>
                      <div
                        className={courseStyle.childCompoStyle}
                        style={{ marginLeft: 5 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={filterValues?.durationOptions.includes(item.duration)} // Check if duration is selected
                            onChange={() => handleDurationChange(item.duration)} // Toggle duration selection
                          />
                        </div>
                        <div className={courseStyle.subCatText}>
                          {item.duration}
                        </div>
                      </div>
                      <div className={courseStyle.priceText}>{item.count}</div>
                    </div>
                  ))}
                </>
              )}
            </aside>
            <GuidanceCard styles={courseStyle} />
            <div className={courseStyle.buttonsStyle} style={{ marginTop: 20 }}>
              <div className={courseStyle.clearAllButton}>Clear All</div>
              <div
                className={courseStyle.applyFilterButton}
                onClick={() => setFilter(!filter)}
              >
                Apply Filter <ArrowWhiteIcon />
              </div>
            </div>
          </div>
        ) : (
          <div>
            {isLoading ? (
              <div
                style={{
                  display: "grid",
                  placeItems: "center",
                  height: "50vh",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <>
                {getAllCoursesData?.length > 0 ? (
                  <>
                    {getAllCoursesData?.map((item, index) => (
                      <div
                        className={courseStyle.mobileMainCardStyle}
                        onClick={() =>
                          navigate(
                            `/courses/Courses/CourseDetails/${item?._id}`
                          )
                        }
                        key={index}
                      >
                        <img
                          src={getCourseImageUrl(item?.thumbnail)}
                          className={courseStyle.imageView}
                          alt="Thumbnail"
                        />
                        <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                          <div className={courseStyle.categoryStyle}>
                            <div className={courseStyle.businessStyle}>
                              {Array.isArray(item?.category) &&
                                item?.category?.map((item) => (
                                  <>
                                    {/* {item.name} */}
                                    {item?.name && item?.name?.length > 20
                                      ? `${item?.name?.substring(0, 20)}...`
                                      : item?.name}
                                  </>
                                ))}
                            </div>
                            <div className={courseStyle.totalPriceText}>
                              {item?.courseType === "LIVESTREAM" ? (<div className={courseStyle.liveBadge}> • Live</div>) : (<>₹ {item?.price}</>)}
                            </div>
                          </div>
                          <div className={courseStyle.titleStyle}>
                            {item?.title && item?.title?.length > 40
                              ? `${item?.title?.substring(0, 40)}...`
                              : item?.title}
                          </div>
                          <div className={courseStyle.lineStyle} />
                          <div className={courseStyle.categoryStyle}>
                            <div className={courseStyle.ratingText}>
                              <RatingIcon />{" "}
                              <span style={{ marginLeft: 5 }}>
                                {item?.averageRating
                                  ? parseFloat(item.averageRating).toFixed(1)
                                  : 0}
                              </span>
                            </div>
                            <div className={courseStyle.ratingText}>
                              <StudentsIcon />
                              <div style={{ marginLeft: 5 }}>
                                {item?.totalEnrollments}
                                <span className={courseStyle.studentText}>
                                  students
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className={courseStyle.pagination}>
                      <div
                        className={courseStyle.pagination__arrow}
                        onClick={handlePreviousClick}
                        disabled={filterValues.page === 1}
                      >
                        <BackIcon />
                      </div>
                      {renderPageNumbers()}
                      <div
                        className={courseStyle.pagination__arrow}
                        onClick={handleNextClick}
                        disabled={filterValues === pagination?.totalPages}
                      >
                        <ForwardIcon />
                      </div>
                    </div>
                  </>
                ) : (
                  <ErrorPage />
                )}
              </>
            )}
          </div>
        )}
      </div>

      <FeaturesBar styles={courseStyle} />
    </div>
    </div>
  );
};

export default Courses;
